export default __webpack_public_path__ + "static/media/Confectionery8.6270ed9a.png";